import './icons.css'

export default function GithubIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M12 .5C5.37.5 0 5.87 0 12.52c0 5.3 3.438 9.78 8.207 11.387.6.112.793-.26.793-.577 0-.285-.012-1.232-.018-2.238-3.338.726-4.042-1.61-4.042-1.61-.546-1.386-1.334-1.756-1.334-1.756-1.09-.756.083-.741.083-.741 1.205.085 1.84 1.255 1.84 1.255 1.07 1.835 2.807 1.305 3.492.998.108-.783.418-1.305.762-1.605-2.665-.304-5.467-1.367-5.467-6.082 0-1.343.465-2.44 1.235-3.297-.124-.303-.536-1.526.117-3.18 0 0 1.008-.327 3.3 1.255a11.49 11.49 0 0 1 3.003-.404c1.018.005 2.044.138 3.003.404 2.29-1.582 3.297-1.255 3.297-1.255.655 1.654.243 2.877.119 3.18.772.857 1.235 1.954 1.235 3.297 0 4.727-2.807 5.775-5.48 6.073.43.373.815 1.107.815 2.23 0 1.61-.015 2.908-.015 3.304 0 .32.192.694.8.576C20.565 22.297 24 17.82 24 12.52 24 5.87 18.627.5 12 .5z" />
    </svg>
  )
}
